import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';
import { DataDialog } from '../login/verification/dataDialog';
import { SigninComponent } from '../login/signin/signin.component';
import { SignupComponent } from '../login/signup/signup.component';
import { ForgotpasswordComponent } from '../login/forgotpassword/forgotpassword.component';


@Injectable({
  providedIn: 'root'
})
export class MatdialogService {

    isExtraSmall: Observable<BreakpointState>;

    dataDialog:DataDialog = {};

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    constructor(
        private _matDialog: MatDialog,
        private readonly breakpointObserver: BreakpointObserver,
    ) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
    }

    openPopupWithData(data:any, component: ComponentType<any>) {
        const popupDialog = this._matDialog.open(component, {
            data: data,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    openPopupWithOutData(component: ComponentType<any>) {
        const popupDialog = this._matDialog.open(component, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    //TODO átalakítani!!!
    openLogin() {
        const popupDialog = this._matDialog.open(SigninComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    openRegistration() {
        sessionStorage.setItem('displayRegistration',JSON.stringify(true));
        const popupDialog = this._matDialog.open(SignupComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    openForgotPassword() {
        sessionStorage.setItem('displayRegistration',JSON.stringify(true));
        this.dataDialog = {
            verificationUuid: ''
        }
        const popupDialog = this._matDialog.open(ForgotpasswordComponent, {
            data:this.dataDialog,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }
}
